import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { LicenseService } from 'app/core/services/license.service';
import { NotificationService } from 'app/core/services/notification.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LoadingPage } from 'app/shared/components/loading/loading.page.component';
import { Observable } from 'rxjs/Observable';
import { ReplaySubject } from 'rxjs/ReplaySubject';

@Component({
  selector: 'itpx-evaluation-materials',
  templateUrl: './evaluation-materials.component.html'
})
export class EvaluationMaterialsComponent extends LoadingPage implements OnInit {
  private update = new Subject<any>();
  private deliverables: Array<any>;
  private errorMessage: String;
  private errorTitle: String;
  private deliverables$: Observable<any>;
  private state$ = new ReplaySubject<string>(1);

  constructor(
    private licenseService: LicenseService,
    private notificationService: NotificationService,
    private route: ActivatedRoute,
    private router: Router,

  ) {
    super();
  }

  ngOnInit() {
    this.state$.next('loading');
    this.deliverables$ = this.route.params
      .switchMap(params => this.licenseService.getEvaluationDeliverablesNew(params['assignmentId']))
      .map(res => res.data)
      .catch(err => {
        this.router.navigate(['/app']);
        return Observable.empty();
      }).shareReplay(1);

    this.deliverables$.bindToLifecycle(this)
      .subscribe(_ => this.state$.next('ready'), _ => this.state$.next('error'));
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/evaluation/workflow_new/evaluation-materials/evaluation-materials.component.ts